import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { CmsFacade } from '../../cms/facade/cms.facade';
import { RoutingService } from '@boels/helpers';
import { map, take, tap } from 'rxjs';
import { Page } from '@boels/models';

export const CmsRouteResolver: ResolveFn<{
  routeResolver: Page | undefined;
}> = (route: ActivatedRouteSnapshot) => {
  const cmsFacadeService = inject(CmsFacade);
  const routingService = inject(RoutingService);

  return cmsFacadeService.activeLoaded$.pipe(
    map((page) => ({ routeResolver: page })),
    tap((resolvedData) => {
      const newRoute = {
        url: [...route.pathFromRoot.flatMap((v) => v.url)],
        params: { ...route.params },
        queryParams: { ...route.queryParams },
      } as ActivatedRouteSnapshot;
      newRoute.data = {
        ...route.data,
        ...{
          resolvedData: resolvedData,
        },
      };
      routingService.setActivatedRouteSnapshot(newRoute);
    }),
    take(1),
  );
};
